// There's an additional style rule in the the ListItemText component definition
// that applies a heavier font weight to primary children when a secondary child
// isn't present.
export var ListItemTextOverrides = function (theme) { return ({
    MuiListItemText: {
        root: {
            padding: '0 12px',
            marginTop: undefined,
            marginBottom: undefined,
        },
        secondary: {
            fontSize: theme.typography.fontSizeDefault,
        },
        multiline: {
            marginTop: undefined,
            marginBottom: undefined,
        },
    },
}); };
//# sourceMappingURL=ListItemText.overrides.js.map